<div class="container" mat-dialog-title>
  <div class="header-title display-flex align-items-center justify-content-space-between">
    <div class="w-100 display-flex grid-gap-8">
      <input
        #inputElement
        class="input input-title"
        aria-label="label-input"
        [formControl]="title"
        [maxLength]="70"
        (input)="updateWidthFromInput(inputElement)"
        [placeholder]="'Title'" />
      <span class="action-buttons">
        <button
          aria-label="dots-button"
          (menuOpened)="actionItemMenuOpen = true"
          (menuClosed)="actionItemMenuOpen = false"
          [style.opacity]="actionItemMenuOpen ? '1' : undefined"
          [matMenuTriggerFor]="actionItemMenu"
          type="button"
          class="icon-button icon-button-default action-buttons_edit"
          mat-icon-button>
          <app-icon [svg]="EIcon.VERTICAL_DOTS"></app-icon>
        </button>
      </span>
    </div>
    <button
      type="button"
      class="display-flex align-items-center justify-content-center"
      (click)="cancel()"
      mat-icon-button>
      <app-icon [svg]="EIcon.CLOSE" [iconWidth]="20" [iconHeight]="20" [iconColor]="EColorPalette.cGray"></app-icon>
    </button>
  </div>
</div>

<mat-dialog-content *ngIf="form">
  <form [formGroup]="form" class="display-flex flex-column grid-gap-12">
    <ng-container *ngIf="options.controls?.length > 0; else noOptionsTemplate">
      <div formArrayName="options" *ngFor="let option of options.controls; let i = index">
        <div [formGroupName]="i" class="w-100 display-flex flex-column grid-gap-12" #item>
          <div class="w-100 display-flex grid-gap-8 align-items-center option-container">
            <div class="w-100 display-flex align-items-center justify-content-space-between">
              <div class="option-editor-width display-flex align-items-center grid-gap-8">
                <div class="display-flex align-items-center">
                  <mat-icon class="display-flex align-items-center justify-content-center drag-indicator">
                    drag_indicator
                  </mat-icon>

                  <app-color-picker
                    *ngIf="isColorSchemeEnabled && option.get('value')?.value"
                    [small]="true"
                    formControlName="color"
                    class="color-picker-compact"></app-color-picker>
                </div>

                <input
                  #inputElement
                  class="input"
                  aria-label="label-input"
                  formControlName="label"
                  [maxLength]="70"
                  (keydown.enter)="focusNextInput($event)"
                  (input)="updateWidthFromInput(inputElement)"
                  [placeholder]="'Item ' + (i + 1)"
                  [ngStyle]="{ 'font-weight': option.get('group') ? '600' : null }" />

                <div class="display-flex justify-content-space-between">
                  <div class="display-flex grid-gap-4">
                    <button
                      type="button"
                      *ngIf="option.get('value')?.value"
                      class="display-flex align-items-center justify-content-center icon-button"
                      [ngClass]="isDefault(i) ? 'icon-button-default' : ''"
                      mat-icon-button
                      [disabled]="!option.get('label')?.value || !option.get('value')?.value"
                      (click)="setDefault(i)"
                      [matTooltip]="'Set default value'">
                      <app-icon
                        [svg]="EIcon.FLAG"
                        [iconWidth]="16"
                        [iconHeight]="16"
                        [iconColor]="isDefault(i) ? EColorPalette.cGreen : EColorPalette.cGray2"></app-icon>
                    </button>
                    <button
                      type="button"
                      class="display-flex align-items-center justify-content-center icon-button"
                      mat-icon-button
                      (click)="removeOption(i)">
                      <app-icon
                        [svg]="EIcon.BB_TRASH"
                        [iconWidth]="16"
                        [iconHeight]="16"
                        [iconColor]="EColorPalette.cGray2"></app-icon>
                    </button>
                  </div>
                </div>
              </div>
              <button
                *ngIf="!option.get('value')"
                aria-label="toggle-button"
                type="button"
                class="display-flex align-items-center justify-content-center icon-button icon-button-default"
                mat-icon-button
                (click)="setExpanded(i)">
                <app-icon
                  [iconHeight]="16"
                  [iconWidth]="8"
                  [iconColor]="EColorPalette.cGray5"
                  [svg]="isExpanded(i) ? EIcon.ANGLE_UP : EIcon.ANGLE_DOWN"></app-icon>
              </button>
            </div>
          </div>
          <ng-container *ngIf="!option.get('value') && isExpanded(i)">
            <div *ngIf="option.get('group')" formArrayName="group" class="display-flex flex-column grid-gap-12 w-100">
              <div
                *ngFor="let groupItem of option.get('group')['controls']; let j = index"
                [formGroupName]="j"
                class="display-flex grid-gap-8 align-items-center option-container pl-24"
                #group>
                <div class="display-flex align-items-center">
                  <mat-icon class="display-flex align-items-center justify-content-center drag-indicator">
                    drag_indicator
                  </mat-icon>

                  <app-color-picker
                    *ngIf="isColorSchemeEnabled"
                    [small]="true"
                    formControlName="color"
                    class="color-picker-compact"></app-color-picker>
                </div>

                <input
                  #inputElement
                  class="input"
                  aria-label="sub-label-input"
                  formControlName="label"
                  [maxLength]="70"
                  (input)="updateWidthFromInput(inputElement)"
                  (keydown.enter)="focusNextInput($event, i, true)"
                  [placeholder]="'Item ' + (j + 1)" />

                <div class="display-flex grid-gap-4">
                  <button
                    type="button"
                    class="display-flex align-items-center justify-content-center icon-button"
                    [ngClass]="isDefault(i, j) ? 'icon-button-default' : ''"
                    mat-icon-button
                    (click)="setDefault(i, j)"
                    [matTooltip]="'Set default value'">
                    <app-icon
                      [svg]="EIcon.FLAG"
                      [iconWidth]="16"
                      [iconHeight]="16"
                      [iconColor]="isDefault(i, j) ? EColorPalette.cGreen : EColorPalette.cGray2"></app-icon>
                  </button>

                  <button
                    type="button"
                    class="display-flex align-items-center justify-content-center icon-button"
                    mat-icon-button
                    (click)="removeGroupItem(i, j)">
                    <app-icon
                      [svg]="EIcon.BB_TRASH"
                      [iconWidth]="16"
                      [iconHeight]="16"
                      [iconColor]="EColorPalette.cGray2"></app-icon>
                  </button>
                </div>
              </div>
            </div>

            <div class="pl-24">
              <button
                type="button"
                class="display-flex align-items-center justify-content-center options-button options-button-add"
                (click)="addOption(i)"
                mat-button>
                <span class="display-flex align-items-center justify-content-center grid-gap-4 add-button">
                  <app-icon
                    [iconWidth]="16"
                    [iconHeight]="16"
                    [iconColor]="EColorPalette.cGray7"
                    [svg]="EIcon.PLUS"></app-icon>
                  <span>Item</span>
                </span>
              </button>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </form>
</mat-dialog-content>

<div class="display-flex align-items-center justify-content-space-between actions">
  <div class="display-flex grid-gap-8">
    <button
      class="display-flex align-items-center justify-content-center options-button options-button-add"
      (click)="addOptionGroup()"
      mat-button>
      <span class="display-flex align-items-center justify-content-center grid-gap-4 add-button">
        <app-icon [iconWidth]="20" [iconHeight]="20" [iconColor]="EColorPalette.cGray7" [svg]="EIcon.PLUS"></app-icon>
        <span>ITEM GROUP</span>
      </span>
    </button>
    <button
      class="display-flex align-items-center justify-content-center options-button options-button-add"
      (click)="addOption()"
      mat-button>
      <span class="display-flex align-items-center justify-content-center grid-gap-4 add-button">
        <app-icon [iconWidth]="20" [iconHeight]="20" [iconColor]="EColorPalette.cGray7" [svg]="EIcon.PLUS"></app-icon>
        <span>ITEM</span>
      </span>
    </button>
  </div>
  <div class="display-flex grid-gap-4">
    <button
      class="display-flex align-items-center justify-content-center"
      (click)="pasteOptionsFromClipboard()"
      [matTooltip]="'Paste'"
      mat-icon-button>
      <mat-icon class="content-options">content_paste_go</mat-icon>
    </button>
    <button
      class="display-flex align-items-center justify-content-center"
      (click)="copyOptionsToClipboard()"
      [matTooltip]="'Copy'"
      mat-icon-button>
      <mat-icon class="content-options">content_copy</mat-icon>
    </button>
  </div>
</div>

<mat-menu #actionItemMenu="matMenu" class="menu-with-backdrop actions-menu">
  <button type="button" class="actions-menu_item" mat-menu-item (click)="toggleColorScheme()">
    <div class="display-flex justify-content-space-between info-item">
      <span class="text-color dark">Add a color scheme</span>
      <app-icon *ngIf="isColorSchemeEnabled" [svg]="EIcon.CHECK_YES"></app-icon>
    </div>
  </button>
</mat-menu>

<ng-template #noOptionsTemplate>
  <div class="display-flex align-items-center justify-content-center no-options-container">
    <svg width="120" height="111" viewBox="0 0 120 111" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M64.2736 110.937C39.1671 111.73 11.2625 105.159 2.80298 81.588C-6.24967 56.3648 7.67981 29.6298 29.4556 13.9244C51.0926 -1.68081 80.5042 -5.85692 101.832 10.1651C122.239 25.4951 123.715 54.1758 114.817 78.0497C107.072 98.8316 86.5076 110.235 64.2736 110.937Z"
        fill="#4EB08D" />
      <path
        d="M13.1937 27.5932C13.1937 22.0517 17.6943 17.5593 23.2461 17.5593H99.8953C105.447 17.5593 109.948 22.0517 109.948 27.5932V91.5593C109.948 97.1009 105.447 101.593 99.8953 101.593H23.2461C17.6943 101.593 13.1937 97.1009 13.1937 91.5593V27.5932Z"
        fill="#D6D4D4" />
      <path
        d="M14.4503 28.8475C14.4503 23.3059 18.9509 18.8136 24.5026 18.8136H98.6387C104.191 18.8136 108.691 23.3059 108.691 28.8475V90.3051C108.691 95.8466 104.191 100.339 98.6387 100.339H24.5026C18.9509 100.339 14.4503 95.8466 14.4503 90.3051V28.8475Z"
        fill="white" />
      <path
        d="M91.0877 38.4846C90.589 39.0333 89.7252 39.0333 89.2265 38.4846L83.0855 31.7284C82.3529 30.9224 82.9258 29.6314 84.0161 29.6314H96.2981C97.3884 29.6314 97.9613 30.9224 97.2287 31.7284L91.0877 38.4846Z"
        fill="#4EB08D" />
      <path
        d="M25.7592 32.6102C25.7592 31.2248 26.8843 30.1017 28.2723 30.1017H60.9424C62.3303 30.1017 63.4555 31.2248 63.4555 32.6102V35.1186C63.4555 36.504 62.3303 37.6271 60.9424 37.6271H28.2723C26.8843 37.6271 25.7592 36.504 25.7592 35.1186V32.6102Z"
        fill="#DADADA" />
      <path
        d="M37.0681 33.8644C37.0681 37.3279 34.2552 40.1356 30.7853 40.1356C27.3155 40.1356 24.5026 37.3279 24.5026 33.8644C24.5026 30.4009 27.3155 27.5932 30.7853 27.5932C34.2552 27.5932 37.0681 30.4009 37.0681 33.8644Z"
        fill="#4EB08D" />
      <path
        d="M29.8429 30.7288C29.8429 30.2093 30.2649 29.7881 30.7853 29.7881C31.3058 29.7881 31.7277 30.2093 31.7277 30.7288V37C31.7277 37.5195 31.3058 37.9407 30.7853 37.9407C30.2649 37.9407 29.8429 37.5195 29.8429 37V30.7288Z"
        fill="white" />
      <path
        d="M27.644 34.8051C27.1235 34.8051 26.7016 34.3839 26.7016 33.8644C26.7016 33.3449 27.1235 32.9237 27.644 32.9237H33.9267C34.4472 32.9237 34.8691 33.3449 34.8691 33.8644C34.8691 34.3839 34.4472 34.8051 33.9267 34.8051H27.644Z"
        fill="white" />
      <path
        d="M24.5026 48.2881C24.5026 46.9027 25.6278 45.7797 27.0157 45.7797H96.1256C97.5136 45.7797 98.6387 46.9027 98.6387 48.2881V87.1695C98.6387 88.5549 97.5136 89.678 96.1256 89.678H27.0157C25.6278 89.678 24.5026 88.5549 24.5026 87.1695V48.2881Z"
        fill="#D6D4D4" />
      <path
        d="M25.7592 49.5424C25.7592 48.157 26.8843 47.0339 28.2723 47.0339H94.8691C96.257 47.0339 97.3822 48.157 97.3822 49.5424V85.9153C97.3822 87.3006 96.257 88.4237 94.8691 88.4237H28.2722C26.8843 88.4237 25.7592 87.3006 25.7592 85.9153V49.5424Z"
        fill="#EEEEEE" />
      <path
        d="M33.2984 58.9492C33.2984 57.5638 34.4236 56.4407 35.8115 56.4407H87.3298C88.7178 56.4407 89.8429 57.5638 89.8429 58.9492V62.7119C89.8429 64.0973 88.7178 65.2203 87.3298 65.2203H35.8115C34.4236 65.2203 33.2984 64.0973 33.2984 62.7119V58.9492Z"
        fill="#83C8AF" />
      <path
        d="M33.2984 58.9492C33.2984 57.5638 34.4236 56.4407 35.8115 56.4407H87.3298C88.7178 56.4407 89.8429 57.5638 89.8429 58.9492V61.4576C89.8429 62.843 88.7178 63.9661 87.3298 63.9661H35.8115C34.4236 63.9661 33.2984 62.843 33.2984 61.4576V58.9492Z"
        fill="#4EB08D" />
      <path
        d="M33.2984 72.7458C33.2984 71.3604 34.4236 70.2373 35.8115 70.2373H87.3298C88.7178 70.2373 89.8429 71.3604 89.8429 72.7458V76.5085C89.8429 77.8939 88.7178 79.017 87.3298 79.017H35.8115C34.4236 79.017 33.2984 77.8939 33.2984 76.5085V72.7458Z"
        fill="#83C8AF" />
      <path
        d="M33.2984 72.7458C33.2984 71.3604 34.4236 70.2373 35.8115 70.2373H87.3298C88.7178 70.2373 89.8429 71.3604 89.8429 72.7458V75.2542C89.8429 76.6396 88.7178 77.7627 87.3298 77.7627H35.8115C34.4236 77.7627 33.2984 76.6396 33.2984 75.2542V72.7458Z"
        fill="#4EB08D" />
    </svg>
  </div>
</ng-template>
